// extracted by mini-css-extract-plugin
export default {"container":"Brand_container__Z5Xl4","brand":"Brand_brand__DjXZh","image":"Brand_image__+V0aj","text":"Brand_text__3OGCo","buttons":"Brand_buttons__tS7cW"};